import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";

export const requestDeleteMarketingTemplate = async (
  name: string
): Promise<{ ok: boolean }> => {
  return await instance.delete(
    `${ApiRoutesMarketing.Templates}/${encodeURIComponent(name)}`
  );
};
